import Cookies from "js-cookie";
import moment from "moment";
import ReactGA from 'react-ga';

const TRACKING_ID = 'G-CQW0D6F4D6';
ReactGA.initialize(TRACKING_ID);
export const setToLocalStorage = (key, Data) => {
  let localStorageValue = btoa(Data);
  localStorage.setItem(key, localStorageValue);
};

export const getFromLocalStorage = (key) => {
  let getLocalStorageValue = "";
  let v = localStorage.getItem(key);
  if (!v) {
    v = "";
  }
  getLocalStorageValue = atob(v);
  return getLocalStorageValue;
};

export const removeFromLocalStorage = (key) => {
  localStorage.removeItem(key);
};

let regexp = /android|iphone|kindle|ipad/i;
export const isMobileDevice = regexp.test(navigator.userAgent);

export const cleanObject = (obj) => {
  for (var propName in obj) {
    if (
      obj[propName] == null ||
      obj[propName] === undefined ||
      obj[propName] === ""
    ) {
      delete obj[propName];
    }
  }
  return obj;
};

export const dateOrdinal = (d) =>
  d +
  (31 === d || 21 === d || 1 === d
    ? "st"
    : 22 === d || 2 === d
      ? "nd"
      : 23 === d || 3 === d
        ? "rd"
        : "th");

export const getLocalString = (value) => {
  return value.toLocaleString();
};

export function getObject(objName, arr) {
  for (let i = 0; i < arr.length; i++) {
    if (objName in arr[i]) {
      return arr[i][objName];
    }
  }
  return null;
}

export const getFromCookie = (key) => {
  let value;
  if (typeof Cookies !== "undefined") {
    value = Cookies.get(key);
  }
  return value;
};

export const setToCookie = (key, payload) => {
  Cookies.set(key, payload);
};

export const removeFromCookie = (key) => {
  Cookies.remove(key);
};

export const isMobile = () => {
  let regexp = /android|iphone|kindle|ipad/i;
  let isMobileDevice = regexp.test(navigator.userAgent);
  return isMobileDevice;
};


export const getkey = (gamblingLimit, timeLimit) => {
  if (gamblingLimit == "DepositLimits" && timeLimit == "Daily") {
    return "dailyDepositLimit"
  }
  if (gamblingLimit == "DepositLimits" && timeLimit == "Weekly") {
    return "weeklyDepositLimit"
  }
  if (gamblingLimit == "DepositLimits" && timeLimit == "Monthly") {
    return "monthlyDepositLimit"
  }
  if (gamblingLimit == "BettingLimits" && timeLimit == "Daily") {
    return "dailyStakeLimit"
  }
  if (gamblingLimit == "BettingLimits" && timeLimit == "Weekly") {
    return "weeklyStakeLimit"
  }
  if (gamblingLimit == "BettingLimits" && timeLimit == "Monthly") {
    return "monthlyStakeLimit"
  }
  if (gamblingLimit == "SelfExclusionLimits") {
    return "selfExclusion"
  }
  if (gamblingLimit == "TimeLimits") {
    return "timeLimit"
  }
 
}

export const getStartDate = (dateType) =>{
    if (dateType == "last24hrs") {
      return  moment().subtract(24, 'hours').format('YYYY-MM-DDTHH:mm:ss.SSS[Z]')
    }
    if (dateType == "lastWeek") {
      return  moment().subtract(1, 'week').format('YYYY-MM-DDTHH:mm:ss.SSS[Z]')
    }
    if (dateType == "lastMonth") {
      return  moment().subtract(1, 'month').format('YYYY-MM-DDTHH:mm:ss.SSS[Z]')
    }
    if (dateType == "last6months") {
      return  moment().subtract(6, 'month').format('YYYY-MM-DDTHH:mm:ss.SSS[Z]')
    }
    if (dateType == "lastYears") {
      return  moment().subtract(1, 'year').format('YYYY-MM-DDTHH:mm:ss.SSS[Z]')
    }
}


export const trackPageView = (page) => {
  ReactGA.set({ page });
  ReactGA.pageview(page);
};

export const trackEvent = (category, action, label) => {
  ReactGA.event({
    category: category,
    action: action,
    label: label,
  });
};

export const buildGameLaunchUrl = (game, options = {}) => {
  const params = new URLSearchParams();
  // Essential fields required by GameLaunch.js
  if (game?.game_code) params.set('gamecode', game.game_code);
  if (game?.provider) params.set('provider', game.provider);
  if (game?.aggregator_type) params.set('aggregator', game.aggregator_type);
  if (game?.name) params.set('name', game.name);
  // Fields used only for specific providers
  if (game?.gamekind) params.set('gamekind', game.gamekind);
  if (game?.gamevariant) params.set('gamevariant', game.gamevariant);
  if (game?.charged) params.set('charged', game.charged);
  // Menu navigation fields (TopGamesList only)
  if (game?.labelName) params.set('labelname', game.labelName);
  if (game?.menuLink) params.set('menulink', game.menuLink);
  // Control flags
  params.set('gameclose', options.gameClose !== false ? 'true' : 'false');
  if (options.returnPath) params.set('returnpath', options.returnPath);
  return `/gamelaunch?${params.toString()}`;
};